import { sagas as emergencyContactsSagas } from './modules/emergencyContacts'

export default [...emergencyContactsSagas]
